import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Button } from '@mui/material';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  setMessageShownAt,
  shouldShowUpgradeMessage,
} from './useAppUpgradeNotification.utils';

export const useAppUpgradeNotification = (): void => {
  const { t } = useTranslation();
  const snackbarRef = useRef<SnackbarKey>();

  const handleClickUpgrade = async (): Promise<void> => {
    await AppUpdate.openAppStore();

    if (snackbarRef.current) {
      closeSnackbar(snackbarRef.current);
      snackbarRef.current = undefined;
    }
  };

  useEffect(() => {
    shouldShowUpgradeMessage().then((shouldShow) => {
      if (!shouldShow) {
        return;
      }

      snackbarRef.current = enqueueSnackbar(t('home.upgrade.message'), {
        variant: 'warning',
        persist: true,
        action: () => (
          <Button
            size="small"
            variant="watchduty-text-uppercase"
            onClick={handleClickUpgrade}
          >
            {t('home.upgrade.cta')}
          </Button>
        ),
      });

      setMessageShownAt(new Date());
    });

    return () => {
      if (snackbarRef.current) {
        closeSnackbar(snackbarRef.current);
        snackbarRef.current = undefined;
      }
    };
  }, [t]);
};
